import React, { FC } from 'react'
import ContentLoader from 'react-content-loader'

const GroupStatusLabelContentFetching: FC = () => (
  <ContentLoader height={50}>
    <rect x="12" y="4" rx="16" ry="16" width="120" height="32" />
    <rect x="144" y="4" rx="16" ry="16" width="100" height="32" />
    <rect x="254" y="4" rx="16" ry="16" width="100" height="32" />
  </ContentLoader>
)

export { GroupStatusLabelContentFetching }
